import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-list-3',
  templateUrl: './3.component.html',
  styleUrls: ['./3.component.scss'],
})
export class CuiList3Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
